import { ModuleWithProviders } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { AuthGuard } from "@atenea-cms";
import { AwardListComponent } from "./award-list/award-list.component";

const routes: Routes = [
  {
    path: "awards",
    component: AwardListComponent,
    canActivate: [AuthGuard],
  },
];

export const AwardsRoutes: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/awards/awards.routes.ts